"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const hui_1 = require("@mit/hui");
const ContactTracingApi_1 = __importDefault(require("../../api/ContactTracingApi"));
const Formatters_1 = require("../../common/Formatters");
const UnauthModal_1 = __importDefault(require("../common/UnauthModal"));
const PersonProfilePicture_1 = __importDefault(require("../common/PersonProfilePicture"));
const CovidPersonApi_1 = __importDefault(require("../../api/CovidPersonApi"));
const ContactCommentsComponent = ({ caseGuid, person, contactGuid, roles }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isError, setError] = (0, react_1.useState)(false);
    const [unauth, setUnauth] = (0, react_1.useState)(false);
    const [comments, setComments] = (0, react_1.useState)([]);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [commentMessage, setCommentMessage] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        fetchComments();
    }, []);
    const getContactPerson = (mit_id) => {
        return new Promise((resolve) => __awaiter(void 0, void 0, void 0, function* () {
            let res = yield CovidPersonApi_1.default.fetchPerson(mit_id);
            if (res.item)
                resolve(res.item);
            else
                resolve(null);
        }));
    };
    const fetchComments = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (contactGuid) {
            let response = yield ContactTracingApi_1.default.fetchContactComments(caseGuid, contactGuid);
            if (response.error) {
            }
            else {
                if (response.items) {
                    setLoading(false);
                    setComments(response.items);
                }
            }
        }
        else {
            let response = yield ContactTracingApi_1.default.fetchComments(caseGuid);
            if (response.error) {
            }
            else {
                if (response.items) {
                    let data = yield Promise.all(response.items.map((o) => __awaiter(void 0, void 0, void 0, function* () {
                        if (o.contact_mit_id)
                            return Object.assign(Object.assign({}, o), { contactPerson: yield getContactPerson(o.contact_mit_id) });
                        else
                            return o;
                    })));
                    setLoading(false);
                    setComments(data);
                }
            }
        }
    });
    const postComment = () => {
        setSubmitting(true);
        setCommentMessage("");
        if (contactGuid) {
            ContactTracingApi_1.default.postContactComment(caseGuid, contactGuid, commentMessage).then((response) => {
                if (response.error) {
                    setSubmitting(false);
                }
                else if (response.unauth) {
                    setSubmitting(false);
                    setUnauth(true);
                }
                else {
                    if (response.items) {
                        setSubmitting(false);
                        fetchComments();
                    }
                }
            });
        }
        else {
            ContactTracingApi_1.default.postComment(caseGuid, commentMessage).then((response) => {
                if (response.error) {
                    setSubmitting(false);
                }
                else if (response.unauth) {
                    setSubmitting(false);
                    setUnauth(true);
                }
                else {
                    if (response.items) {
                        setSubmitting(false);
                        fetchComments();
                    }
                }
            });
        }
    };
    if (isError)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Oops.. something went wrong", type: hui_1.ErrorType.Generic });
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "container" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-3", style: { opacity: "0.5" } }, { children: (0, Formatters_1.shortToday)() })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-9" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.TextArea, { name: "comment", rows: 3, value: commentMessage, placeholderText: "Type something here", onChange: (e) => setCommentMessage(e.currentTarget.value) }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row p-3" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.Button, { isBusy: submitting, text: "Save", type: hui_1.ButtonType.Primary, theme: "medical", onClick: () => postComment() }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row no-gutters ml-4 d-none" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "meh" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "profile-pic" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "user" }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "contactname" }, { children: person.display_name }))] })) })) }))] }))] }))] })) })), (0, jsx_runtime_1.jsx)("hr", {}), isLoading && (0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] }), !isLoading && ((0, jsx_runtime_1.jsx)(React.Fragment, { children: comments.map((itm, i) => {
                    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "container" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mx-12 align-items-center" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-sm-3" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row", style: { opacity: "0.5" } }, { children: (0, Formatters_1.displayDateTimeShort)(itm.created_on) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row", style: { opacity: "0.5" } }, { children: ["Posted by: ", itm.person.display_name] })), itm.contact_mit_id && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row my-1" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col p-0 m-0" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "meh" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "profile-pic" }, { children: (0, jsx_runtime_1.jsx)(PersonProfilePicture_1.default, { id: itm.contact_mit_id, person: itm.person.display_name }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "contactname", style: { opacity: "0.5" } }, { children: itm.contactPerson.email.toLowerCase() }))] })) })) })))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-9" }, { children: itm.comment }))] })), (0, jsx_runtime_1.jsx)("hr", {})] }), i.toString()));
                }) })), (0, jsx_runtime_1.jsx)(UnauthModal_1.default, { show: unauth, onClose: () => setUnauth(false) })] }));
};
exports.default = ContactCommentsComponent;
